import { Link } from "react-router-dom";
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import "./Scan.css";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const UpdateConsignment = () => {
  const [selectedRows, setSelectedRows] = useState(new Set()); // For pin code table
  const [selectedFranchise, setSelectedFranchise] = useState(null); // For franchise details
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const { bookingId } = useParams(); // Get the bookingId from the URL
  const axiosPrivate = useAxiosPrivate();
  const GET_BOOKING_URL = "api/get-booking";
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [bookings, setBookings] = useState([]); // To store list of users
  const [bookings, setBookings] = useState("");
  const [ConsignerName, setConsignerName] = useState("");
  const [Address1, setAddress1] = useState("");
  const [Address2, setAddress2] = useState("");
  const [ConsignerCity, setConsignerCity] = useState("");
  const [ConsignerPincode, setPincode] = useState("");
  const [consigneeMobile, setConsigneeMobile] = useState("");
  const [netAmount, setNetAmount] = useState("");
  const [TotalGst, setTotalGst] = useState("");
  const [OtherCharges, setOtherCharges] = useState("");
  const [paymentMode, setPaymentMode] = useState("");

  const [NewConsigneeName, setNewConsigneeName] = useState("");
  const [NewConsignmentType, setNewConsignmentType] = useState("");
  const [NewShippingMode, setNewShippingMode] = useState("");
  const [NewConsigneeMobile, setNewConsigneeMobile] = useState("");
  const [NewConsAddress1, setNewConsAddress1] = useState("");
  const [NewConsAddress2, setNewConsAddress2] = useState("");
  const [NewConsigneeCity, setNewConsigneeCity] = useState("");
  const [NewPincodeId, setNewPincodeId] = useState("");
  const [NewDestinationFr_Id, setNewDestinationFr_Id] = useState("");
  const [NewSector, setNewSector] = useState("");
  const [NewGoodsName, setNewGoodsName] = useState("");
  const [NewGoodsValue, setNewGoodsValue] = useState("");
  const [NewQuantity, setNewQuantity] = useState("");
  const [NewWeight, setNewWeight] = useState("");
  const [NewGst, setNewGst] = useState("");
  const [NewOtherCharges, setNewOtherCharges] = useState("");
  const [NewEwayBillNos, setNewEwayBillNos] = useState("");
  const [NewAmount, setNewAmount] = useState("");

  const [EditConsigneeName, setEditConsigneeName] = useState("");
  const [EditConsignmentType, setEditConsignmentType] = useState("");
  const [EditShippingMode, setEditShippingMode] = useState("");
  const [EditConsigneeMobile, setEditConsigneeMobile] = useState("");
  const [EditConsAddress1, setEditConsAddress1] = useState("");
  const [EditConsAddress2, setEditConsAddress2] = useState("");
  const [EditConsigneeCity, setEditConsigneeCity] = useState("");
  const [EditPincodeId, setEditPincodeId] = useState("");
  const [EditDestinationFr_Id, setEditDestinationFr_Id] = useState("");
  const [EditSector, setEditSector] = useState("");
  const [EditGoodsName, setEditGoodsName] = useState("");
  const [EditGoodsValue, setEditGoodsValue] = useState("");
  const [EditQuantity, setEditQuantity] = useState("");
  const [EditWeight, setEditWeight] = useState("");
  const [EditGst, setEditGst] = useState("");
  const [EditOtherCharges, setEditOtherCharges] = useState("");
  const [EditEwayBillNos, setEditEwayBillNos] = useState("");
  const [EditAmount, setEditAmount] = useState("");
  const [EditConsignmentId, setEditConsignmentId] = useState("");
  const [Fr_Id, setFr_Id] = useState("");

  const GET_CONSIGNMENT_URL = "api/get-consignment";
  const DELETE_CONSIGNMENT_URL = "api/delete-consignment";
  const UPDATE_CONSIGNMENT_URL = "api/update-consignment";
  const ADD_CONSIGNMENT_URL = "api/add-consignment";
  const UPDATE_BOOKING_URL = "api/update-booking";
  const [errMsg, setErrMsg] = useState("");
  const errRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);



  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedAwbToDelete, setSelectedAwbToDelete] = useState(null);
  const handleDeleteConsignment = async () => {
    try {
      console.log("Deleting AWB:", selectedAwbToDelete);
      // Call your API here to delete using selectedAwbToDelete
      // await axiosPrivate.delete(api/delete-consignment/${selectedAwbToDelete});

      // After delete success:
      setShowDeleteConfirm(false);
      setSelectedAwbToDelete(null);

      // Optionally refresh your list
      // fetchData();
    } catch (error) {
      console.error("Failed to delete consignment:", error);
    }
  };

  const getEditConsignmentPopUp = async (awbNumber) => {
    console.log(awbNumber);
    const headers = {
      "Content-Type": "application/json",
    };
    const data = {
      awb_number: awbNumber,
    };

    try {
      const response = await axiosPrivate.get(GET_CONSIGNMENT_URL, {
        params: data,
        headers,
        withCredentials: true, // Ensures cookies are sent with the request if needed
      });
      console.log(response.data);

      // setEditConsignment(response.data); // Store the fetched data into the user state
      setEditConsigneeName(response.data.consignee_name);
      setEditConsignmentType(response.data.consignment_type);
      setEditShippingMode(response.data.shipping_mode);
      setEditConsigneeMobile(response.data.consignee_mobile);
      setEditConsAddress1(response.data.consignee_address1);
      setEditConsAddress2(response.data.consignee_address2);
      setEditConsigneeCity(response.data.consignee_city);
      setEditPincodeId(response.data.pincode_id);
      setEditDestinationFr_Id(response.data.destination_franchise_id);
      setEditSector(response.data.sector);
      setEditGoodsName(response.data.goods_name);
      setEditGoodsValue(response.data.goods_value);
      setEditQuantity(response.data.quantity);
      setEditWeight(response.data.weight);
      setEditGst(response.data.gst);
      setEditOtherCharges(response.data.other_charges);
      setEditEwayBillNos(response.data.eway_bill_nos);
      setEditAmount(response.data.amount);
      setEditConsignmentId(response.data.consignment_id);

      setShowModalEdit(true);
      setLoading(false); // Stop loading spinner
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to load data");
      setLoading(false); // Set loading to false even if there is an error
    }
  };

  const fetchData = async () => {
    const headers = {
      "Content-Type": "application/json",
    };
    const data = {
      booking_id: bookingId,
    };

    try {
      const response = await axiosPrivate.get(GET_BOOKING_URL, {
        params: data,
        headers,
        withCredentials: true, // Ensures cookies are sent with the request if needed
      });
      console.log(response.data);
      setBookings(response.data); // Store the fetched data into the user state
      setLoading(false); // Stop loading spinner

      setConsignerName(response.data.consigner_name);
      setAddress1(response.data.consigner_address1);
      setAddress2(response.data.consigner_address2);
      setConsignerCity(response.data.consigner_city);
      setPincode(response.data.consigner_pincode);
      setConsigneeMobile(response.data.consigner_mobile);
      setNetAmount(response.data.net_amount);
      setTotalGst(response.data.total_gst);
      setPaymentMode(response.data.payment_mode);
      setOtherCharges(response.data.other_charges);
      setFr_Id(response.data.franchise_id);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to load data");
      setLoading(false); // Set loading to false even if there is an error
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle form completion
  const handleSaveEditConsignment = async () => {
    setIsSubmitting(true);

    // Basic validation (adjust as needed)
    if (!EditConsigneeName || !EditConsAddress1 || !EditConsigneeMobile || !EditConsignmentId) {
      alert(
        "Please fill out all required fields: Consignee Name, Address1, Mobile, and Consignment ID."
      );
      setIsSubmitting(false);
      return;
    }

    // Prepare form data
    const formData = {



      "consignment_id": EditConsignmentId,
      "consignment_type": EditConsignmentType,
      "shipping_mode": EditShippingMode,
      "consignee_mobile": EditConsigneeMobile,
      "consignee_name": EditConsigneeName,
      "consignee_address1": EditConsAddress1,
      "consignee_address2": EditConsAddress2,
      "consignee_city": EditConsigneeCity,
      "pincode_id": EditPincodeId,
      "destination_franchise_id": EditDestinationFr_Id,
      "sector": EditSector,
      "goods_name": EditGoodsName,
      "goods_value": EditGoodsValue,
      "eway_bill_nos": EditEwayBillNos === "" ? null : EditEwayBillNos ?? 0,
      "quantity": EditQuantity,
      "weight": EditWeight,
      "amount": EditAmount,
      "gst": EditGst === "" ? null : EditGst ?? 0,
      "other_charges": EditOtherCharges === "" ? null : EditOtherCharges ?? 0,


    };
    fetchData();
    try {
      console.log("formData", formData);
      // Send POST request
      const response = await axiosPrivate.post(
        UPDATE_CONSIGNMENT_URL,
        formData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      console.log("Consignment update successful:", response.data);
      alert("Consignment updated successfully!");

      // Optionally reset or redirect
      // resetForm();
      fetchData();
    } catch (error) {
      console.error("Error submitting form data:", error);
      alert(
        "An error occurred while updating the consignment. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle form completion
  const handleSaveEditConsignerInformation = async () => {
    // setIsSubmitting(true);

    // // Basic validation (adjust as needed)
    // if (!EditConsigneeName || !EditConsAddress1 || !EditConsigneeMobile || !EditConsignmentId) {
    //   alert("Please fill out all required fields: Consignee Name, Address1, Mobile, and Consignment ID.");
    //   setIsSubmitting(false);
    //   return;
    // }

    // Prepare form data

    const formData = {
      booking_id: bookingId,
      franchise_id: Fr_Id,
      booking_date: bookings.booking_date,
      payment_mode: paymentMode,
      customer_id: null,
      consigner_name: ConsignerName,
      consigner_address1: Address1,
      consigner_address2: Address2,
      consigner_pincode: ConsignerPincode,
      consigner_city: ConsignerCity,
      consigner_mobile: consigneeMobile,
      net_amount: netAmount,
      total_gst: TotalGst === "" ? null : TotalGst ?? 0,
      other_charges: OtherCharges === "" ? null : OtherCharges ?? 0,
    };

    try {
      console.log("formData", formData);
      // Send POST request
      const response = await axiosPrivate.post(UPDATE_BOOKING_URL, formData, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      console.log("Consignment update successful:", response.data);
      alert("Consignment updated successfully!");

      // Optionally reset or redirect
      // resetForm();
    } catch (error) {
      console.error("Error submitting form data:", error);
      alert(
        "An error occurred while updating the consignment. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleSaveAddConsignment = async () => {
    setIsSubmitting(true);

    // Basic validation (adjust as needed)
    // if ( !EditConsigneeName || !EditConsAddress1 || !EditConsigneeMobile || !EditConsignmentId ) {
    //   alert(
    //     "Please fill out all required fields: Consignee Name, Address1, Mobile, and Consignment ID."
    //   );
    //   setIsSubmitting(false);
    //   return;
    // }

    // Prepare form data
    const formData = {
      booking_id: bookingId,
      consignee_name: NewConsigneeName,
      consignment_type: NewConsignmentType,
      shipping_mode: NewShippingMode,
      consignee_mobile: NewConsigneeMobile,
      consignee_address1: NewConsAddress1,
      consignee_address2: NewConsAddress2,
      consignee_city: NewConsigneeCity,
      pincode_id: NewPincodeId,
      destination_franchise_id: NewDestinationFr_Id,
      sector: NewSector,
      goods_name: NewGoodsName,
      goods_value: NewGoodsValue,
      eway_bill_nos: NewEwayBillNos === "" ? null : NewEwayBillNos ?? 0,
      quantity: NewQuantity,
      weight: NewWeight,
      amount: NewAmount,
      gst: NewGst === "" ? null : NewGst ?? 0,
      other_charges: NewOtherCharges === "" ? null : NewOtherCharges ?? 0,


    };

    try {
      console.log("formData", formData);
      // Send POST request
      const response = await axiosPrivate.post(
        ADD_CONSIGNMENT_URL,
        formData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      console.log("Consignment update successful:", response.data);
      alert("Consignment Added successfully!");

      // Optionally reset or redirect
      // resetForm();
      fetchData();
    } catch (error) {
      console.error("Error submitting form data:", error);
      alert(
        "An error occurred while updating the consignment. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // useEffect(() => {
  //   if (bookings?.consignments?.length > 0) {
  //     const allIds = new Set(bookings.consignments.map(consignment => consignment.consignment_id));
  //     setSelectedRows(allIds);
  //   }
  // }, [bookings]);

  // const toggleRowSelection = (id) => {
  //   const newSelectedRows = new Set(selectedRows);
  //   if (newSelectedRows.has(id)) {
  //     newSelectedRows.delete(id);
  //   } else {
  //     newSelectedRows.add(id);
  //   }
  //   setSelectedRows(newSelectedRows);
  // };

  const delete_consignment = async (consignmentId) => {
    try {
      const response = await axiosPrivate.delete(
        `${DELETE_CONSIGNMENT_URL}?consignment_id=${consignmentId}`,
        {
          withCredentials: true,
        }
      );
      // You can handle response here if needed
      setShowDeleteConfirm(false);
      fetchData();
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 409) {
        setErrMsg(err.response?.data.message);
      } else {
        setErrMsg("Deletion Failed! \n" + err.response?.data.message);
      }
      errRef.current.focus();
    }
  };

  const handleShowEdit = () => setShowModalEdit(true);
  const handleCloseEdit = () => setShowModalEdit(false);
  const handleShowAdd = () => setShowModalAdd(true);
  const handleCloseAdd = () => setShowModalAdd(false);

  return (
    <>
      <section className="servicenewbody">
        <div className="wrapper10">
          <h3>Edit Consignment Booking</h3>
          <Row>
            <Col md={5}>
              <div className="table-responsive">
                <center>
                  <h5 style={{ color: "#085184" }}>Consigner Information</h5>
                </center>

                <div className=" input-boxs">
                  <label htmlFor="name">Name : </label>
                  <input
                    type="name"
                    className="form-control"
                    value={ConsignerName}
                    onChange={(e) => setConsignerName(e.target.value)}
                  />
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="name">Address 1 : </label>
                  <input
                    type="name"
                    className="form-control"
                    value={Address1}
                    onChange={(e) => setAddress1(e.target.value)}
                  />
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="name">Address 2 : </label>
                  <input
                    type="name"
                    className="form-control"
                    value={Address2}
                    onChange={(e) => setAddress2(e.target.value)}
                  />
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="name">City : </label>
                  <input
                    type="name"
                    className="form-control"
                    value={ConsignerCity}
                    onChange={(e) => setConsignerCity(e.target.value)}
                  />
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="name">Pincode : </label>
                  <input
                    type="name"
                    className="form-control"
                    value={ConsignerPincode}
                    onChange={(e) => setPincode(e.target.value)}
                  />
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="name">Mobile : </label>
                  <input
                    type="name"
                    className="form-control"
                    value={consigneeMobile}
                    onChange={(e) => setConsigneeMobile(e.target.value)}
                  />
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="name">Booking date : </label>
                  <p className="multip">{bookings.booking_date}</p>
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="name">Net amount : </label>
                  <input
                    type="name"
                    className="form-control"
                    value={netAmount}
                    onChange={(e) => setNetAmount(e.target.value)}
                  />
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="name">Total gst : </label>
                  <input
                    type="name"
                    className="form-control"
                    value={TotalGst}
                    onChange={(e) => setTotalGst(e.target.value)}
                  />
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="name">Other charges : </label>
                  <input
                    type="name"
                    className="form-control"
                    value={OtherCharges}
                    onChange={(e) => setOtherCharges(e.target.value)}
                  />
                  {/* {showValidation && !name && (<div className="mt-1 reqstyl"> * Name is required</div>)}    */}
                </div>

                <div className=" input-boxs">
                  <label htmlFor="paymentMode">Payment </label>

                  <select
                    className="newregselect"
                    name="paymentMode"
                    value={paymentMode}
                    onChange={(e) => setPaymentMode(e.target.value)}
                  >
                    <option value="">Select Mode</option>
                    <option value="Cash">Cash</option>
                    <option value="Online">Online</option>
                    {/* <option value="Pan Card">Pan Card</option> */}
                  </select>
                </div>
              </div>
            </Col>

            <Col md={7}>
              {/* <center><h5 style={{color:"#085184"}}>Consignment list</h5></center> */}
              <div className="d-flex justify-content-between align-items-center w-100">
                <div className="flex-grow-1 text-center">
                  <h5 style={{ color: "#085184", margin: 0 }}>
                    Consignment list
                  </h5>
                </div>
                <button
                  type="button"
                  onClick={handleShowAdd}
                  className="btn btn-success add-bt"
                >
                  Add
                </button>
              </div>

              {/* <span className="d-flex justify-content-end gap-2"><center><h5 style={{color:"#085184"}}>Consignment list</h5></center>
            <button type="button" onClick={handleShowEdit} className="btn btn-success d-block top-bt">
            
    Add
  </button></span> */}
              <div className="table-responsive contab">
                {/* <center><h3>Consignment list</h3></center> */}
                <table border="1" id="customers2">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th className="fixed-width">AWB</th>
                      <th className="fixed-width">Consignee Name</th>
                      <th className="fixed-width">Consignment Type</th>
                      <th className="fixed-width">Shipping Mode</th>
                      <th className="fixed-width">Consignee Mobile</th>
                      <th className="fixed-width">Consignee Address</th>
                      <th className="fixed-width">Consignee City</th>
                      <th className="fixed-width">Pincode</th>
                      <th className="fixed-width">Dest Franchise</th>
                      <th className="fixed-width">Sector</th>
                      <th className="fixed-width">Goods Name</th>
                      <th className="fixed-width">Goods Value</th>
                      <th className="fixed-width">eway bill nos</th>
                      <th className="fixed-width">Quantity</th>
                      <th className="fixed-width">Weight</th>
                      <th className="fixed-width">Amount</th>
                      <th className="fixed-width">GST</th>
                      <th className="fixed-width">Other charges</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookings &&
                      bookings.consignments &&
                      bookings.consignments.length > 0 ? (
                      bookings.consignments.map((consignment) => (
                        <tr key={consignment.consignment_id}>
                          <td>
                            <center>
                              {/* <input
              type="checkbox"
              checked={selectedRows.has(consignment.consignment_id)}
              onChange={() => toggleRowSelection(consignment.consignment_id)}
            /> */}
                              <button
                                type="button"
                                className="btn btn-warning d-block top-bt2"
                                onClick={() =>
                                  getEditConsignmentPopUp(
                                    consignment.awb_number
                                  )
                                }
                              >
                                <i className="bx bxs-edit icon"></i>
                              </button>
                            </center>
                          </td>
                          <td>
                            <center>
                              {/* <button
                                type="button"
                                className="btn btn-danger d-block top-bt2"
                                onClick={() =>
                                  delete_consignment(consignment.consignment_id)
                                }
                              >
                                <i>Delete</i>
                              </button> */}


                              <button
                                type="button"
                                className="btn btn-danger d-block top-bt2"
                                onClick={() => {
                                  setSelectedAwbToDelete(consignment.awb_number);
                                  setShowDeleteConfirm(true);
                                }}
                              >
                                <i className="bx bxs-trash icon"></i>
                              </button>

                              <Modal show={showDeleteConfirm} onHide={() => setShowDeleteConfirm(false)} centered
                                className="transparent-modal"
                                backdropClassName="transparent-backdrop">
                                <Modal.Header closeButton>
                                  <Modal.Title>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <p>Are you sure you want to delete this consignment?</p>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="secondary" onClick={() => setShowDeleteConfirm(false)}>
                                    No
                                  </Button>
                                  {/* <Button variant="danger" onClick={() => handleDeleteConsignment()}> */}
                                  <Button variant="danger" onClick={() => delete_consignment(consignment.consignment_id)}>


                                    Yes, Delete
                                  </Button>
                                </Modal.Footer>
                              </Modal>




                            </center>
                          </td>

                          <td>{consignment.awb_number}</td>
                          <td>{consignment.consignee_name}</td>
                          <td>{consignment.consignment_type}</td>
                          <td>{consignment.shipping_mode}</td>
                          <td>{consignment.consignee_mobile}</td>
                          <td>
                            {consignment.consignee_address1},{" "}
                            {consignment.consignee_address2}
                          </td>
                          <td>{consignment.consignee_city}</td>
                          <td>{consignment.pincode}</td>
                          <td>
                            {consignment.destination_franchise_name} -{" "}
                            {consignment.destination_franchise_code}
                          </td>
                          <td>{consignment.sector}</td>
                          <td>{consignment.goods_name}</td>
                          <td>{consignment.goods_value}</td>
                          <td>{consignment.eway_bill_nos}</td>
                          <td>{consignment.quantity}</td>
                          <td>{consignment.weight}</td>
                          <td>{consignment.amount}</td>
                          <td>{consignment.gst}</td>
                          <td>{consignment.other_charges}</td>
                          <td>{consignment.consignment_id}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="20">
                          <center>No consignments found.</center>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <center>
                <button
                  type="button"
                  className="btn btn-success d-block top-bt"
                  onClick={handleSaveEditConsignerInformation}
                >
                  Submit
                </button>
              </center>
            </Col>
          </Row>
        </div>
      </section>

      <Modal
        show={showModalEdit}
        onHide={handleCloseEdit}
        dialogClassName="modal-100w"
        size="xl"
        aria-labelledby="add-consignment-modal"
      >
        <section className="franchbody">
          <div className="wrapper10">
            {/* <Modal.Header closeButton> */}
            {/* <Modal.Title id="add-consignment-modal">
            <center>Add New Consignment</center>
            </Modal.Title> */}
            {/* </Modal.Header> */}
            <Modal.Body>
              <Form>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Consignee Name </label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={EditConsigneeName}
                          onChange={(e) => setEditConsigneeName(e.target.value)}
                        />

                        {/* {showValidation2 && !mobile2 && (
                <div className="mt-1 reqstyl"> *Mobile2 is required</div>
              )}             */}
                      </div>
                      {/* console.log(NewConsigneeName); */}
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Consignment Type </label>

                        <input
                          type="text"
                          className="form-control"
                          value={EditConsignmentType}
                          onChange={(e) =>
                            setEditConsignmentType(e.target.value)
                          }
                        />
                        {/* {showValidation2 && !email && (
                <div className="mt-1 reqstyl"> *Email is required</div>
              )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Shipping Mode </label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={EditShippingMode}
                          onChange={(e) => setEditShippingMode(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Consignee Mobile</label>

                        <input
                          type="text"
                          className="form-control"
                          value={EditConsigneeMobile}
                          onChange={(e) =>
                            setEditConsigneeMobile(e.target.value)
                          }
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Cons. Address1</label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={EditConsAddress1}
                          onChange={(e) => setEditConsAddress1(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Cons. Address2 </label>

                        <input
                          type="text"
                          className="form-control"
                          value={EditConsAddress2}
                          onChange={(e) => setEditConsAddress2(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Consignee City</label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={EditConsigneeCity}
                          onChange={(e) => setEditConsigneeCity(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email"> Pincode Id </label>

                        <input
                          type="text"
                          className="form-control"
                          value={EditPincodeId}
                          onChange={(e) => setEditPincodeId(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Destination Fr_Id</label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={EditDestinationFr_Id}
                          onChange={(e) =>
                            setEditDestinationFr_Id(e.target.value)
                          }
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Sector</label>

                        <input
                          type="text"
                          className="form-control"
                          value={EditSector}
                          onChange={(e) => setEditSector(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Goods Name</label>
                        <input
                          type="mobile2"
                          className="form-control"
                          value={EditGoodsName}
                          onChange={(e) => setEditGoodsName(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Goods Value</label>
                        <input
                          type="text"
                          className="form-control"
                          value={EditGoodsValue}
                          onChange={(e) => setEditGoodsValue(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Quantity</label>
                        <input
                          type="mobile2"
                          className="form-control"
                          value={EditQuantity}
                          onChange={(e) => setEditQuantity(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Weight</label>
                        <input
                          type="text"
                          className="form-control"
                          value={EditWeight}
                          onChange={(e) => setEditWeight(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Amount</label>
                        <input
                          type="mobile2"
                          className="form-control"
                          value={EditAmount}
                          onChange={(e) => setEditAmount(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Gst</label>
                        <input
                          type="text"
                          className="form-control"
                          value={EditGst}
                          onChange={(e) => setEditGst(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Other Charges</label>
                        <input
                          type="mobile2"
                          className="form-control"
                          value={EditOtherCharges}
                          onChange={(e) => setEditOtherCharges(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Eway BillNos</label>
                        <input
                          type="text"
                          className="form-control"
                          value={EditEwayBillNos}
                          onChange={(e) => setEditEwayBillNos(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                {/* Add more fields here as needed */}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseEdit}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSaveEditConsignment} className="btn btn-warning">
                Save Consignment
              </Button>
            </Modal.Footer>
          </div>
        </section>
      </Modal>










      <Modal
        show={showModalAdd}
        onHide={handleCloseAdd}
        dialogClassName="modal-100w"
        size="xl"
        aria-labelledby="add-consignment-modal"
      >
        <section className="franchbody">
          <div className="wrapper10">
            {/* <Modal.Header closeButton> */}
            {/* <Modal.Title id="add-consignment-modal">
            <center>Add New Consignment</center>
            </Modal.Title> */}
            {/* </Modal.Header> */}
            <Modal.Body>
              <Form>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Consignee Name </label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={NewConsigneeName}
                          onChange={(e) => setNewConsigneeName(e.target.value)}
                        />

                        {/* {showValidation2 && !mobile2 && (
                <div className="mt-1 reqstyl"> *Mobile2 is required</div>
              )}             */}
                      </div>
                      {/* console.log(NewConsigneeName); */}
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Consignment Type </label>

                        <input
                          type="text"
                          className="form-control"
                          value={NewConsignmentType}
                          onChange={(e) =>
                            setNewConsignmentType(e.target.value)
                          }
                        />
                        {/* {showValidation2 && !email && (
                <div className="mt-1 reqstyl"> *Email is required</div>
              )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Shipping Mode </label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={NewShippingMode}
                          onChange={(e) => setNewShippingMode(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Consignee Mobile</label>

                        <input
                          type="text"
                          className="form-control"
                          value={NewConsigneeMobile}
                          onChange={(e) =>
                            setNewConsigneeMobile(e.target.value)
                          }
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Cons. Address1</label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={NewConsAddress1}
                          onChange={(e) => setNewConsAddress1(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Cons. Address2 </label>

                        <input
                          type="text"
                          className="form-control"
                          value={NewConsAddress2}
                          onChange={(e) => setNewConsAddress2(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Consignee City</label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={NewConsigneeCity}
                          onChange={(e) => setNewConsigneeCity(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email"> Pincode Id </label>

                        <input
                          type="text"
                          className="form-control"
                          value={NewPincodeId}
                          onChange={(e) => setNewPincodeId(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Destination Fr_Id</label>

                        <input
                          type="mobile2"
                          className="form-control"
                          value={NewDestinationFr_Id}
                          onChange={(e) =>
                            setNewDestinationFr_Id(e.target.value)
                          }
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Sector</label>

                        <input
                          type="text"
                          className="form-control"
                          value={NewSector}
                          onChange={(e) => setNewSector(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Goods Name</label>
                        <input
                          type="mobile2"
                          className="form-control"
                          value={NewGoodsName}
                          onChange={(e) => setNewGoodsName(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Goods Value</label>
                        <input
                          type="text"
                          className="form-control"
                          value={NewGoodsValue}
                          onChange={(e) => setNewGoodsValue(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Quantity</label>
                        <input
                          type="mobile2"
                          className="form-control"
                          value={NewQuantity}
                          onChange={(e) => setNewQuantity(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Weight</label>
                        <input
                          type="text"
                          className="form-control"
                          value={NewWeight}
                          onChange={(e) => setNewWeight(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Amount</label>
                        <input
                          type="mobile2"
                          className="form-control"
                          value={NewAmount}
                          onChange={(e) => setNewAmount(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Gst</label>
                        <input
                          type="text"
                          className="form-control"
                          value={NewGst}
                          onChange={(e) => setNewGst(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="mobile2">Other Charges</label>
                        <input
                          type="mobile2"
                          className="form-control"
                          value={NewOtherCharges}
                          onChange={(e) => setNewOtherCharges(e.target.value)}
                        />
                        {/* {showValidation2 && !mobile2 && (
                 <div className="mt-1 reqstyl"> *Mobile2 is required</div>
               )}             */}
                      </div>
                    </Col>
                    <Col>
                      <div className=" input-boxs">
                        <label htmlFor="email">Eway BillNos</label>
                        <input
                          type="text"
                          className="form-control"
                          value={NewEwayBillNos}
                          onChange={(e) => setNewEwayBillNos(e.target.value)}
                        />
                        {/* {showValidation2 && !email && (
                 <div className="mt-1 reqstyl"> *Email is required</div>
               )}            */}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
                {/* Add more fields here as needed */}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseAdd}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSaveAddConsignment} className="btn btn-success">
                Add Consignment
              </Button>
            </Modal.Footer>
          </div>
        </section>
      </Modal>
    </>
  );
};

export default UpdateConsignment;
